import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["onClose", "className", "withPortal"];
import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import { useMergeRef } from "../../hooks/useMergeRef";
import { addColorSet } from "../../styles";
import { OverlayBackdrop, staticSet } from "./OverlayBackdrop";
export var Backdrop = /*#__PURE__*/React.forwardRef(function Backdrop(_ref, ref) {
  var _ref$onClose = _ref.onClose,
      onClose = _ref$onClose === void 0 ? function () {} : _ref$onClose,
      className = _ref.className,
      withPortal = _ref.withPortal,
      props = _objectWithoutProperties(_ref, _excluded);

  var backdropRef = useMergeRef(ref);
  /* if backdrop is clicked, execute onClose */

  var onClick = function onClick(event) {
    if (event.target === backdropRef.current) {
      onClose(event);
    }
  };
  /* if escape key is pressed, execute onClose */


  var onKeydown = function onKeydown(event) {
    if (event.keyCode === 27 || event.code === 'Escape') {
      onClose(event);
    }
  };

  useEffect(function () {
    /* add event listener for escape key press */
    window.addEventListener('keydown', onKeydown, true);
    /* clean up */

    return function () {
      window.removeEventListener('keydown', onKeydown, true);
    };
  });
  var backdrop = /*#__PURE__*/React.createElement(OverlayBackdrop, Object.assign({
    ref: backdropRef,
    onClick: onClick,
    className: addColorSet(staticSet, className)
  }, props));
  return withPortal ? /*#__PURE__*/ReactDOM.createPortal(backdrop, document.body) : backdrop;
});
/**
* **Backdrop** ![Status: Production](https://img.shields.io/badge/PRODUCTION-%2357B560|height=14)
*
* [GitHub](https://ghe.spotify.net/encore/web/tree/master/src/core/components/Backdrop) | [Storybook](https://encore-web.spotify.net/?path=/docs/components-backdrop--default) | [Encore](https://encore.spotify.net/web/components/backdrop) | [Figma](https://www.figma.com/file/bnQXqGkLeiTlbk8JXGDcsX/Encore-Web---Light-Theme-Toolkit?node-id=0:1206) |
*
* Backdrop is a tinted overlay on page content, under a popover or model. It disables interactive elements on the page, and uses the "Over media" color set.
*
* @example
* () => <Backdrop />;
*
*/

export default Backdrop;